<template>
  <ModuleWrapper :moduleId="moduleId">
    <template #main>
      <div class="tw-border-t tw-p-4">
        <StudioSelect
          id="domain-type-select"
          label="Domain Type"
          class="tw-mb-4"
          :options="[{ value: 'Email', label: 'Email' }]"
          :value="domainType"
          @change="e => (domainType = e.target.value)"
        />
        <template v-if="domainType === 'Email'">
          <StudioInput
            id="email-input"
            label="Email Address (for sending registration/reminder notifications)"
            placeholder="yourname@example.com"
            class="tw-mb-2"
            :modelValue="emailInputValue"
            :inlineError="emailInvalidError"
            @update:modelValue="value => handleEmailInput(value)"
          />
          <div class="tw-mt-4 tw-flex tw-justify-end">
            <StudioButton
              :disabled="isCreateEmailSignatureLoading || !!emailInvalidError"
              trackingId="create-email-signature-button"
              @click="onContinueClick"
            >
              {{ isCreateEmailSignatureLoading ? 'Loading...' : 'Continue' }}
            </StudioButton>
          </div>
        </template>
      </div>
    </template>
  </ModuleWrapper>
</template>

<script lang="ts">
import debounce from 'lodash.debounce';
import { defineComponent } from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';

import ModuleWrapper from '../ModuleWrapper.vue';

import { REGEX_STRINGS } from '@/constants.js';
import StudioButton from '@/studioComponents/StudioButton.vue';
import StudioInput from '@/studioComponents/StudioInput.vue';
import StudioSelect from '@/studioComponents/StudioSelect.vue';

export default defineComponent({
  name: 'SelectDomain',
  components: {
    ModuleWrapper,
    StudioSelect,
    StudioInput,
    StudioButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      domainType: 'Email',
      emailInputValue: ''
    };
  },
  mounted() {
    this.emailInputValue = this.vanityEmailDomain?.email_sender;
  },
  computed: {
    ...mapState('customDomain', {
      isCreateEmailSignatureLoading: 'isCreateEmailSignatureLoading',
      isDeleteEmailSignatureLoading: 'isDeleteEmailSignatureLoading',
      vanityEmailDomain: 'vanityEmailDomain'
    }),
    ...mapGetters('org', {
      org: 'getCurrentOrg'
    }),
    emailInvalidError(): string {
      if (this.org?.email_sender) {
        return '';
      }

      if (!this.emailInputValue) {
        return 'Required';
      }

      return REGEX_STRINGS.email.test(this.emailInputValue.trim())
        ? ''
        : 'Invalid Email Address. Also, uppercase letters are not accepted by email server';
    }
  },
  watch: {
    isDeleteEmailSignatureLoading(newIsDeleteEmailSignatureLoading, oldIsDeleteEmailSignatureLoading) {
      if (!newIsDeleteEmailSignatureLoading && oldIsDeleteEmailSignatureLoading) {
        this.emailInputValue = '';
      }
    }
  },
  methods: {
    ...mapActions('customDomain', ['createEmailSignature', 'onClickNext', 'getVanityEmailDomainsList']),
    onContinueClick() {
      this.createEmailSignature({
        orgId: this.org.id,
        email: this.emailInputValue.trim(),
        provider: this.org?.email_service_provider ?? ''
      }).then(() => {
        this.getVanityEmailDomainsList(this.org.id);
      });
    },
    handleEmailInput: debounce(function (value) {
      // @ts-ignore:
      this.emailInputValue = value;
    }, 500)
  }
});
</script>
